import { render, staticRenderFns } from "./InventoryEvent.vue?vue&type=template&id=fef2127c&scoped=true"
import script from "./InventoryEvent.vue?vue&type=script&lang=js"
export * from "./InventoryEvent.vue?vue&type=script&lang=js"
import style0 from "./InventoryEvent.vue?vue&type=style&index=0&id=fef2127c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef2127c",
  null
  
)

export default component.exports